import { useQuery } from "react-query";

import { fetchFavouriteItems } from "./favouriteItems.fetcher";
import { favouriteItemsKey } from "./favouriteItems.constants";

export function useFavouriteItemsQuery() {
  return useQuery({ queryKey: favouriteItemsKey, queryFn: fetchFavouriteItems, staleTime: 2 * 60 * 1000 });
}
